(function () {
  function parsePromoPool(root) {
    var el = root.querySelector("[data-ec-promo-pool]");
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || "[]");
      return Array.isArray(data)
        ? data
            .map(function (t) {
              return String(t || "").trim();
            })
            .filter(Boolean)
        : [];
    } catch (e) {
      return [];
    }
  }

  function shuffle(list) {
    var arr = list.slice();
    for (var i = arr.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  /* Fill promo cards from the shared copy library (random each visit).
     Across a long page / infinite scroll, prefer unused lines first so
     each visible promo card shows different copy until the pool repeats. */
  function applyPromoTexts(root, scope) {
    var pool = parsePromoPool(root);
    if (!pool.length) return;
    var host = scope || root;
    var slots = host.querySelectorAll("[data-ec-promo-text]:not([data-ec-promo-set])");
    if (!slots.length) return;

    if (!root._ecPromoUsed) root._ecPromoUsed = [];

    slots.forEach(function (slot) {
      var used = root._ecPromoUsed;
      var available = pool.filter(function (text) {
        return used.indexOf(text) === -1;
      });
      if (!available.length) {
        used.length = 0;
        available = pool.slice();
      }
      var pick = shuffle(available)[0];
      slot.textContent = pick;
      slot.setAttribute("data-ec-promo-set", "1");
      used.push(pick);
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll("[data-ec-faq-item]");

    function setOpen(item, open) {
      var trigger = item.querySelector("[data-ec-faq-trigger]");
      var panel = item.querySelector("[data-ec-faq-panel]");
      if (!trigger || !panel) return;

      if (open) {
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        panel.setAttribute("aria-hidden", "false");
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else {
        item.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
        panel.setAttribute("aria-hidden", "true");
        panel.style.maxHeight = "0px";
      }
    }

    function syncOpenHeights() {
      items.forEach(function (item) {
        if (!item.classList.contains("is-open")) return;
        var panel = item.querySelector("[data-ec-faq-panel]");
        if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
      });
    }

    items.forEach(function (item) {
      var trigger = item.querySelector("[data-ec-faq-trigger]");
      var panel = item.querySelector("[data-ec-faq-panel]");
      if (!trigger || !panel) return;

      // Match initial Liquid state (first item may already be open)
      if (item.classList.contains("is-open")) {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else {
        panel.style.maxHeight = "0px";
      }

      trigger.addEventListener("click", function () {
        var wasOpen = item.classList.contains("is-open");
        items.forEach(function (other) {
          setOpen(other, false);
        });
        if (!wasOpen) setOpen(item, true);
      });
    });

    window.addEventListener("resize", syncOpenHeights);
  }

  function absoluteUrl(url) {
    if (!url) return "";
    try {
      return new URL(url, window.location.origin).href;
    } catch (e) {
      return url;
    }
  }

  /* Preview-only: reveal already-rendered cards as you scroll */
  function initPreviewInfinite(root) {
    var more = root.querySelector("[data-ec-more]");
    var note = root.querySelector("[data-ec-pager-note]");
    var sentinel = root.querySelector("[data-ec-sentinel]");
    var loading = root.querySelector("[data-ec-loading]");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ec-product]"));
    if (!cards.length) return;

    var pageSize = Number(
      (more && more.getAttribute("data-page-size")) ||
        (sentinel && sentinel.getAttribute("data-page-size")) ||
        9
    );
    var shown = pageSize;
    var total = cards.length;
    var busy = false;

    function render() {
      cards.forEach(function (card, i) {
        card.hidden = i >= shown;
      });
      if (note) {
        note.textContent =
          "You've viewed " + Math.min(shown, total) + " of " + total + " products.";
      }
      if (shown >= total) {
        if (more) {
          more.hidden = true;
          more.disabled = true;
        }
        if (sentinel) sentinel.hidden = true;
      }
    }

    function loadMore() {
      if (busy || shown >= total) return;
      busy = true;
      if (loading) loading.hidden = false;
      window.setTimeout(function () {
        shown = Math.min(shown + pageSize, total);
        render();
        busy = false;
        if (loading) loading.hidden = true;
      }, 280);
    }

    if (more) {
      more.hidden = false;
      more.addEventListener("click", loadMore);
    }

    if (sentinel && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore();
          });
        },
        { rootMargin: "240px 0px" }
      );
      io.observe(sentinel);
    }

    render();
  }

  /* Live Shopify: fetch next collection page and append products */
  function initShopifyInfinite(root) {
    var pager = root.querySelector("[data-ec-pager]");
    var grid = root.querySelector(".elfink-collection__grid");
    var sentinel = root.querySelector("[data-ec-sentinel]");
    var note = root.querySelector("[data-ec-pager-note]");
    var loading = root.querySelector("[data-ec-loading]");
    var more = root.querySelector("[data-ec-more]");
    if (!pager || !grid) return;

    var nextUrl = absoluteUrl(pager.getAttribute("data-ec-next") || "");
    var total = Number(pager.getAttribute("data-ec-total") || 0);
    var viewed = Number(pager.getAttribute("data-ec-viewed") || 0);
    var busy = false;
    var io = null;

    if (!nextUrl && !sentinel && !more) return;

    function updateNote() {
      if (!note || !total) return;
      note.textContent = "You've viewed " + viewed + " of " + total + " products.";
    }

    function setFinished() {
      nextUrl = "";
      pager.setAttribute("data-ec-next", "");
      if (sentinel) sentinel.hidden = true;
      if (more) {
        more.hidden = true;
        more.disabled = true;
      }
      if (io) {
        io.disconnect();
        io = null;
      }
    }

    function finish() {
      busy = false;
      if (loading) loading.hidden = true;
      if (!nextUrl) setFinished();
    }

    function loadMore() {
      if (busy || !nextUrl) return;
      busy = true;
      if (loading) loading.hidden = false;
      if (more) more.disabled = true;

      fetch(nextUrl, { credentials: "same-origin" })
        .then(function (res) {
          if (!res.ok) throw new Error("Failed to load more products");
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var nextRoot =
            doc.querySelector("[data-elfink-collection]") ||
            doc.querySelector(".elfink-collection");
          var nextGrid = (nextRoot || doc).querySelector(".elfink-collection__grid");
          var nextPager = (nextRoot || doc).querySelector("[data-ec-pager]");
          var appended = 0;

          /* Do not re-fire view_item_list / collection_viewed on infinite scroll.
             That would inflate catalog list views and poison ad learning. */
          if (nextGrid) {
            Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
              if (child.classList && child.classList.contains("elfink-collection__empty")) {
                return;
              }
              var node = document.importNode(child, true);
              grid.appendChild(node);
              applyPromoTexts(root, node);
              appended += 1;
            });
          }

          if (nextPager) {
            nextUrl = absoluteUrl(nextPager.getAttribute("data-ec-next") || "");
            var nextViewed = Number(nextPager.getAttribute("data-ec-viewed") || 0);
            var nextTotal = Number(nextPager.getAttribute("data-ec-total") || 0);
            if (nextViewed) viewed = nextViewed;
            else viewed = grid.querySelectorAll("[data-ec-product]").length;
            if (nextTotal) total = nextTotal;
          } else {
            nextUrl = "";
            viewed = grid.querySelectorAll("[data-ec-product]").length;
          }

          /* If nothing useful came back, stop to avoid loops */
          if (!appended && !nextUrl) nextUrl = "";

          pager.setAttribute("data-ec-next", nextUrl);
          pager.setAttribute("data-ec-viewed", String(viewed));
          pager.setAttribute("data-ec-total", String(total));
          updateNote();
          if (more && nextUrl) more.disabled = false;
          finish();
        })
        .catch(function () {
          if (more) {
            more.disabled = false;
            more.hidden = false;
          }
          finish();
        });
    }

    if (more) {
      more.addEventListener("click", function (event) {
        event.preventDefault();
        loadMore();
      });
    }

    if (sentinel && nextUrl && "IntersectionObserver" in window) {
      /* Auto-load mode: keep button as hidden fallback */
      if (more) {
        more.hidden = true;
        more.disabled = false;
      }
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadMore();
          });
        },
        { root: null, rootMargin: "400px 0px", threshold: 0 }
      );
      io.observe(sentinel);
    } else if (nextUrl && more) {
      more.hidden = false;
      more.disabled = false;
    }

    /* Scroll fallback if IntersectionObserver misses the sentinel */
    if (nextUrl) {
      var onScroll = function () {
        if (!nextUrl || busy) return;
        var marker = sentinel || more || pager;
        if (!marker) return;
        var rect = marker.getBoundingClientRect();
        if (rect.top < window.innerHeight + 420) loadMore();
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      window.setTimeout(onScroll, 200);
    }
  }

  function init(root) {
    if (!root || root.dataset.ecReady === "1") return;
    root.dataset.ecReady = "1";
    applyPromoTexts(root);
    initFaq(root);
    if (root.getAttribute("data-ec-preview") === "1") {
      initPreviewInfinite(root);
    } else {
      initShopifyInfinite(root);
    }
  }

  function boot() {
    document.querySelectorAll("[data-elfink-collection]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector("[data-elfink-collection]");
    if (root) {
      root.dataset.ecReady = "";
      init(root);
    }
  });
})();
